(() => {
  const angular = window.angular;

  angular.module('app').config(ForensicReconstructionRouter);

  ForensicReconstructionRouter.$inject = ['$stateProvider'];

  function ForensicReconstructionRouter($stateProvider) {
    $stateProvider.state('member.project.forensicReconstruction', {
      url: '/forensic-reconstruction',
      template: `<new-front-container path="'forensic-reconstruction'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.ForensicReconstruction" | translate}}',
      },
    });
  }
})();
